import { ACTION_STATES, ComplexAction, createHandler, createReducer } from "core/actions";
import { cloneDeep } from "lodash";
import log from "loglevel";

export const initState = {
    loadStatus: ACTION_STATES.NO_REQUEST,
    form: {
        reviewStatusType: null,
    },
};

export class CHANGE_FORM extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("callRdx", state, payload);
        let form = {};
        if (Array.isArray(payload)) {
            form = { ...cloneDeep(state.form) };

            for (let change of payload) {
                log.debug(change);
                form[change.attribute] =
                    change.value !== "Invalid date"
                        ? change.attribute.match(/advType/) && !change.value
                            ? []
                            : change.value
                        : null;
            }
        }
        if (payload && payload.attribute) {
            form = {
                ...cloneDeep(state.form),
                [payload.attribute]:
                    payload.value !== "Invalid date"
                        ? payload.attribute.match(/advType/) && !payload.value
                            ? []
                            : payload.value
                        : null,
            };
        }
        
        
        
        
        
        
        
        

        
        
        
        
        
        
        
        
        
        
        
        
        return state;
    }
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            loadStatus: ACTION_STATES.SUCCESS,
            list: payload.data.results,
            totalCount: payload.data.totalCount,
            form: {
                ...state.form,
                filmRelease: payload.filmRelease
                    ? {
                        ...payload.filmRelease,
                        value: payload.filmRelease.id,
                        label: payload.filmRelease.title,
                    }
                    : state.form.filmRelease
                        ? { ...state.form.filmRelease }
                        : null,
            },
            loadFilmReleaseId: null,
        });
    }
}

export const actions = {
    CHANGE_FORM: new CHANGE_FORM("loadStatus"),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
